interface SelectedCategoryProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subcategories?: Array<any>;
}

export const areSubCategoriesExist = (
  selectedCategory: SelectedCategoryProps
): boolean => {
  return (
    (selectedCategory?.subcategories &&
      !!selectedCategory.subcategories.length) ||
    false
  );
};

export const getKeyWords = (sentence: string): string[] => {
  const keyWords = sentence
    // remove double spaces, keep special characters
    .replace(/\s{2,}/g, ' ')
    .split(' ')
    .map((word) => word.toLowerCase())
    .filter((el) => el != null);

  return [...Array.from(new Set(keyWords))];
};
